// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { microphone16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-microphone': IconMicrophone;
    }
}

/**
 * The icon component for the 'microphone' icon
 */
export class IconMicrophone extends IconSvg {
    public constructor() {
        super(microphone16X16);
    }
}

registerIconSvg('icon-microphone', IconMicrophone);
export const iconMicrophoneTag = 'nimble-icon-microphone';
